import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ADVANCED_SEARCH_SETTINGS_DEFAULTS } from '../../../../interfaces/advancedSearch.interface';

@Component({
    selector: 'app-advanced-search-text',
    templateUrl: './advanced-search-text.component.html',
    styleUrls: ['./advanced-search-text.component.scss']
})
export class AdvancedSearchTextComponent implements OnInit {

    @Input() control: FormControl;
    @Input() label: string;

    readonly DEFAULTS = ADVANCED_SEARCH_SETTINGS_DEFAULTS;

    constructor() { }

    ngOnInit(): void { }
}
